import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FNSimple } from '../models/FNSimple';
@Component({
  selector: 'app-fN-simple',
  templateUrl: './fN-simple.component.html'
})
export class FNSimpleComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'FNSimple'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  
  	@Input() fNSimple : FNSimple;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

